'use client';

import { motion } from 'framer-motion';
import { SignatureBadgeItem } from '@/types/achievements';
import BadgeUnit from '@/components/features/achievement/unit/badge/BadgeUnit';

interface SignatureBadgeProps {
    badges: SignatureBadgeItem[] | null | undefined;
}

export default function SignatureBadge({ badges = [] }: SignatureBadgeProps) {
    const totalLoops = 3;
    const displayBadges = badges ? badges.slice(0, totalLoops) : [];
    const badgeCount = displayBadges.length;

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            className="flex flex-col justify-center items-center"
        >
            <div className="flex flex-row w-full">
                {displayBadges.map((badge, index) => (
                    <div key={index} className="flex-shrink-0 justify-center w-1/3">
                        <BadgeUnit
                            badgeCd={badge?.badge_cd}
                            achievementScore={badge?.achievement_score}
                            isAwarded={!!badge?.award_date_time}
                        />
                    </div>
                ))}
                {[...Array(totalLoops - badgeCount)].map((_, index) => (
                    <div key={`empty-${index}`} className="flex-shrink-0 justify-center w-1/3">
                        <BadgeUnit badgeCd={''} achievementScore={0} isAwarded={false} />
                    </div>
                ))}
            </div>
        </motion.div>
    );
}
